import React, { FC } from 'react';
import { Alert } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

type Props = {
  profileName?: string;
  profileType?: string;
  reason?: string;
};

const PageAccessError: FC<Props> = ({ profileName, profileType, reason }) => {
  const { t } = useTranslation();

  if (profileName?.includes('undefined')) {
    return null;
  }

  return (
    <div className="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-p-6">
      <Alert variant="warning" title={t('pageAccessError.title')}>
        {reason || t('pageAccessError.message')}
        {profileName && (
          <div className="tw-mt-2 tw-text-sm tw-text-grayscale-100">
            <strong>{t('profile')}:</strong> {profileName}
            {profileType && ` (${profileType})`}
          </div>
        )}
      </Alert>
    </div>
  );
};

export default PageAccessError;
